var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3332 8.14583C44.5624 9.37499 44.5624 11.3542 43.3332 12.5625L35.2291 20.6667L39.6458 39.8125L36.7082 42.7708L28.6249 27.2917L20.4999 35.4167L21.2499 40.5625L19.0208 42.7708L15.3541 36.1458L8.70825 32.4583L10.9166 30.2083L16.1249 30.9792L24.1874 22.9167L8.70825 14.7708L11.6666 11.8333L30.8124 16.25L38.9166 8.14583C40.0833 6.93749 42.1666 6.93749 43.3332 8.14583Z",
    fill: "#062644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.4bacfd374026e740486dc9078c1a9898.svg";
export { ForwardRef as ReactComponent };